import { render, staticRenderFns } from "./activity-workshop-goLogin.vue?vue&type=template&id=1f003590&scoped=true&"
import script from "./activity-workshop-goLogin.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-goLogin.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-goLogin.vue?vue&type=style&index=0&id=1f003590&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f003590",
  null
  
)

export default component.exports